// extracted by mini-css-extract-plugin
module.exports = {"container":"_99551c8aa8--container--PnfcQ","column":"_99551c8aa8--column--N5saw","geosuggest":"_99551c8aa8--geosuggest--DRVBB"};